var _classCallCheck = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/mnt/e/www/joinengineconvas/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

/**
 * Group profile methods. Learn more: https://help.mixpanel.com/hc/en-us/articles/360025333632
 */
var _require = require('./profile_helpers'),
    ProfileHelpers = _require.ProfileHelpers;

var MixpanelGroups =
/*#__PURE__*/
function (_ProfileHelpers) {
  "use strict";

  _inherits(MixpanelGroups, _ProfileHelpers);

  function MixpanelGroups(mp_instance) {
    var _this;

    _classCallCheck(this, MixpanelGroups);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MixpanelGroups).call(this));
    _this.mixpanel = mp_instance;
    _this.endpoint = '/groups';
    return _this;
  }
  /** groups.set_once(group_key, group_id, prop, to, modifiers, callback)
      ---
      The same as groups.set, but adds a property value to a group only if it has not been set before.
  */


  _createClass(MixpanelGroups, [{
    key: "set_once",
    value: function set_once(group_key, group_id, prop, to, modifiers, callback) {
      var identifiers = {
        $group_key: group_key,
        $group_id: group_id
      };

      this._set(prop, to, modifiers, callback, {
        identifiers: identifiers,
        set_once: true
      });
    }
    /**
        groups.set(group_key, group_id, prop, to, modifiers, callback)
        ---
        set properties on a group profile
         usage:
             mixpanel.groups.set('company', 'Acme Inc.', '$name', 'Acme Inc.');
             mixpanel.groups.set('company', 'Acme Inc.', {
                'Industry': 'widgets',
                '$name': 'Acme Inc.',
            });
    */

  }, {
    key: "set",
    value: function set(group_key, group_id, prop, to, modifiers, callback) {
      var identifiers = {
        $group_key: group_key,
        $group_id: group_id
      };

      this._set(prop, to, modifiers, callback, {
        identifiers: identifiers
      });
    }
    /**
     groups.delete_group(group_key, group_id, modifiers, callback)
        ---
        delete a group profile permanently
         usage:
         mixpanel.groups.delete_group('company', 'Acme Inc.');
        */

  }, {
    key: "delete_group",
    value: function delete_group(group_key, group_id, modifiers, callback) {
      var identifiers = {
        $group_key: group_key,
        $group_id: group_id
      };

      this._delete_profile({
        identifiers: identifiers,
        modifiers: modifiers,
        callback: callback
      });
    }
    /**
     groups.remove(group_key, group_id, data, modifiers, callback)
        ---
        remove a value from a list-valued group profile property.
         usage:
         mixpanel.groups.remove('company', 'Acme Inc.', {'products': 'anvil'});
         mixpanel.groups.remove('company', 'Acme Inc.', {
            'products': 'anvil',
            'customer segments': 'coyotes'
        });
        */

  }, {
    key: "remove",
    value: function remove(group_key, group_id, data, modifiers, callback) {
      var identifiers = {
        $group_key: group_key,
        $group_id: group_id
      };

      this._remove({
        identifiers: identifiers,
        data: data,
        modifiers: modifiers,
        callback: callback
      });
    }
    /**
     groups.union(group_key, group_id, data, modifiers, callback)
        ---
        merge value(s) into a list-valued group profile property.
         usage:
         mixpanel.groups.union('company', 'Acme Inc.', {'products': 'anvil'});
         mixpanel.groups.union('company', 'Acme Inc.', {'products': ['anvil'], 'customer segments': ['coyotes']});
        */

  }, {
    key: "union",
    value: function union(group_key, group_id, data, modifiers, callback) {
      var identifiers = {
        $group_key: group_key,
        $group_id: group_id
      };

      this._union({
        identifiers: identifiers,
        data: data,
        modifiers: modifiers,
        callback: callback
      });
    }
    /**
     groups.unset(group_key, group_id, prop, modifiers, callback)
        ---
        delete a property on a group profile
         usage:
         mixpanel.groups.unset('company', 'Acme Inc.', 'products');
         mixpanel.groups.unset('company', 'Acme Inc.', ['products', 'customer segments']);
        */

  }, {
    key: "unset",
    value: function unset(group_key, group_id, prop, modifiers, callback) {
      var identifiers = {
        $group_key: group_key,
        $group_id: group_id
      };

      this._unset({
        identifiers: identifiers,
        prop: prop,
        modifiers: modifiers,
        callback: callback
      });
    }
  }]);

  return MixpanelGroups;
}(ProfileHelpers());

exports.MixpanelGroups = MixpanelGroups;